<template>
  <span 
    v-if="listSelected.length"
    :class="isGalleryModal ? 'text-white': 'text-bc-blue font-semibold'"	
  >
    {{$t('%length% items selected', {length: listSelected.length})}}
    <span 
      class="cursor-pointer"
      :class="isGalleryModal ? 'text-white': 'text-gray-400 hover:text-black'"	
      @click="bcSelectedStore.resetSelected()"
    >
      {{$t('(cancel)')}}
    </span>
  </span>
  <span 
    v-else-if="bcSelectedStore.selectableMap.size && !isGalleryModal" 
    class="text-gray-400 hover:text-black cursor-pointer font-semibold hidden lg:block" 
    @click="bcSelectedStore.selectAll()"
  >
    {{$t('Select all')}}
  </span>
  <span 
    v-else-if="bcSelectedStore.selectableMap.size && isGalleryModal" 
    class="text-white cursor-pointer"	
    @click="selectAllGalleryModal()"
  >
    {{$t('Select all')}}
  </span>
  <span class="mx-2 hidden lg:block" v-if="separator && (listSelected.length || bcSelectedStore.selectableMap.size)">|</span>
</template>

<script>
import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'

export default {
  props: {
    element: {
      type: Object,
      default: null,
    },
    isGalleryModal: {
      type: Boolean,
      default: false,
    },
    selectableItems: {
      type: Array,
      default: null,
    },
    separator: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    // FIXME: optimalize -> do not count children of color + table
    listSelected() {
      return this.bcSelectedStore.listFullySelected.filter((el) => el.type !== 'color-row' && el.type !== 'table-row')
    },
    ...mapStores(useBcSelectedStore)
  },
  methods: {
    selectAllGalleryModal() {
      this.element.children.forEach(item => {
        this.bcSelectedStore.select(item, {isRecursive: true})
      })
    }
  },
};
</script>

<style lang="scss" scoped></style>
